/** Number of items each dashboard section displays. */
export const LATEST_LIMIT = 3

/** react-query cache config shared by the dashboard sections. */
export const QUERY_STALE_TIME_MS = 5 * 60 * 1000
export const QUERY_RETRY = 1

/** Grid layout shared by the cards and skeletons. */
export const GRID_COLS = 3
export const GRID_BREAKPOINTS = [{ maxWidth: 'md' as const, cols: 1 }]

/** Section skeleton sizing. */
export const SKELETON_HEIGHT = 220

/** Project card sizing and status fallback. */
export const PROJECT_COVER_HEIGHT = 120
export const MAX_VISIBLE_AVATARS = 5
export const DEFAULT_STATUS_CONFIG = { color: 'gray', labelKey: 'arc_projects.status_draft' }

/** Navigation target for the "View all projects" link. */
export const PROJECTS_VIEW_ALL_URL = '/arc_projects'
